import { useMutation, useQueryClient } from 'react-query';
import { useToast } from '@razorpay/blade/components';
import { bulkUpdateSalaryComponents } from 'api/gql-utils/overtime/mutations';
import type {
  BulkUpdateOtBehaviourComponentInput,
  BulkUpdateSalaryComponentInput,
} from 'api/gql-utils/overtime/types';
import { parseGraphqlErrorFromExtensions } from 'utils/Api';
import { AppError } from 'utils/AppError';
import { OT_SALARY_COMPONENTS_QUERY_KEY } from './useOtSalaryComponents';

export const toBulkSalaryComponentUpdates = (
  components: BulkUpdateOtBehaviourComponentInput[],
): BulkUpdateSalaryComponentInput[] =>
  components.map((component) => ({
    id: component.componentId,
    category: 'EARNINGS_CATEGORY',
    settings: {
      otBehaviour: { includeInOtWages: component.includeInOtWages },
    },
    updateMask: ['settings.ot_behaviour'],
    componentSource: component.componentSource,
  }));

export function useBulkUpdateOtBehaviour() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (components: BulkUpdateOtBehaviourComponentInput[]) =>
      bulkUpdateSalaryComponents({
        input: {
          updates: toBulkSalaryComponentUpdates(components),
        },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries([OT_SALARY_COMPONENTS_QUERY_KEY]);
      toast.show({ content: 'Salary components updated', color: 'positive' });
    },
    onError: (error: typeof AppError) => {
      toast.show({
        content: parseGraphqlErrorFromExtensions(error),
        color: 'negative',
      });
    },
  });
}
